import React from 'react';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

interface InstantTipProps {
  content: React.ReactNode;
  children: React.ReactNode;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  delay?: number | [number, number];
}

const InstantTip = React.forwardRef<HTMLElement, InstantTipProps>(({ content, children, placement = 'top', delay = 0 }, ref) => (
  <Tippy content={content} placement={placement} delay={delay} arrow={true} ref={ref}>
    <span style={{ display: 'inline-flex' }}>{children}</span>
    </Tippy>
));

InstantTip.displayName = 'InstantTip';

export default InstantTip; 